import { MaybeNil } from '../../../../../utils/interfaces';
import { PopoverPosition } from '@mui/material';

export enum DashboardMediaPopoverMode {
  Add = 'ADD',
  Edit = 'EDIT',
}

export interface IDashboardMediaFormProps {
  mode: DashboardMediaPopoverMode;
  url: MaybeNil<string>;
  onSubmit: (url: string) => void;
  onCancel: () => void;
}

export interface IDashboardMediaPopoverProps
  extends Omit<IDashboardMediaFormProps, 'onCancel'> {
  isOpen: boolean;
  onClose: () => void;
  anchorPosition: PopoverPosition;
}

export type IOpenPopoverProps = Pick<
  IDashboardMediaPopoverProps,
  'anchorPosition' | 'url' | 'onSubmit' | 'mode'
>;
